export class ModelError extends Error {
    model;
    constructor(model, data) {
        super(typeof data === 'string' ? data : data?.message);
        this.model = model;
        this.model = model;
        if (data && typeof data === 'object') {
            Object.assign(this, data);
        }
    }
}
